import { makeAutoObservable } from "mobx";
import { ApiService } from "../api/old_api";
import { message } from "antd";
import { loadCheckoutWidget } from "../utils/loadCheckoutWidget";

export class PayStore {

  isPaymentLoading: boolean = false
  isPayLoad: boolean = false
  isPaymentVisible: boolean = false

  wallets: any[] = []
  activeWallet: any | undefined = undefined

  constructor() {
    makeAutoObservable(this)
  }
  
  setActiveWallet = (val: any | undefined) => this.activeWallet = val
  setWallets = (val: any[]) => this.wallets = val
  setIsPaymentVisible = (val: boolean) => this.isPaymentVisible = val
  setIsPaymentLoading = (val: boolean) => this.isPaymentLoading = val
  setIsPayLoad = (val: boolean) => this.isPayLoad = val

  async fetchWallets() {
    const res: any = await ApiService.loyalty.getMyWallets()

    let lst: any[] = res.wallets

    lst = lst.sort((a, b) => {
      return a.id < b.id ? -1 : (a.id > b.id ? 1 : 0)
    })

    let activeWallet = lst.find(v => v.status === 1)

    this.setWallets(lst)
    this.setActiveWallet(activeWallet)
  }

  async addWallet(cb: (res: any) => void) {
    this.setIsPaymentLoading(true)
    this.setIsPaymentVisible(true)

    const res: any = await ApiService.loyalty.createWallet({})

    if (res.state === 0) {
      return message.error(res.message)
    }

    if (res.state === 1) {
      this.setIsPaymentLoading(false)

      setTimeout(async () => {
        cb(res)

        try {
          await loadCheckoutWidget()

          const checkout = new (window as any).YooMoneyCheckoutWidget({
            confirmation_token: res.payment.confirmation.confirmation_token,
            return_url: null,
            error_callback: (error: any) => {
              console.log(error)
            },
            onSuccess: function () {
              console.log('Payment successful')
            },
            onError: function (error) {
              console.error('Payment error', error)
            }
          })

          checkout.render('payment-formx')
        } catch (e: any) {
          console.log(e)
          message.error('Ошибка загрузки платежной формы')
        }
      }, 1500)

      this.runPaymentChecker(res.payment_id)
    }
  }

  async runPaymentChecker(payment_id: number, callback?: () => void) {
    const inter = setInterval(async () => {
      const res: any = await ApiService.loyalty.orders.checkPayment(payment_id)

      if (res.state === 1) {
        const form = document.getElementById("payment-formx")
        if (form === null) {
          clearInterval(inter)
          return
        }

        if (res.payment_status !== 0) {
          this.fetchWallets()
          clearInterval(inter)
          return
        }
      }
    }, 3000)
  }

}